import React from 'react'

import { DownloadOutlined } from '@ant-design/icons'

interface DownloadLinkProps {
  data: any
  filename: string
}

export const DownloadLink: React.FC<DownloadLinkProps> = ({
  data,
  filename
}) => {
  const handleDownload = () => {
    if (!data) {
      return
    }

    const jsonString = JSON.stringify(data, null, 2)
    const blob = new Blob([jsonString], { type: 'application/json' })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = filename
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  return (
    <a
      onClick={handleDownload}
      className='text-blue-500 hover:text-blue-700 cursor-pointer flex items-center gap-1'
    >
      <DownloadOutlined />
      Download
    </a>
  )
}
